import * as Sentry from "@sentry/react";

import { LUKITA_URL } from "@/config";
import { getHeaders, streamedResponse } from "./utils";

export const execute = async (
  route,
  { method = "GET", body, isStream = false, onStreamMessage, aborter } = {},
) => {
  return fetch(`${LUKITA_URL}${route}`, {
    method,
    body: body ? JSON.stringify(body) : undefined,
    headers: await getHeaders({ "Content-Type": "application/json" }),
    signal: aborter?.abortController()?.signal,
  })
    .then(async (response) => {
      if (!response.ok) {
        // TODO: Create a custom error
        throw new Error((await response.text()) || "Failed to fetch.");
      }

      if (!response.body) {
        // TODO: Create a custom error
        throw new Error("The response body is empty.");
      }

      if (!isStream) return response;
      return streamedResponse(response, {
        abortController: aborter?.abortController,
        onStreamMessage,
      });
    })
    .catch((error) => {
      if (error.name === "AbortError") {
        aborter?.onAbortError?.();
        return;
      }

      Sentry.captureException(error);
      throw error;
    });
};

export const executePost = async (route, body, options = {}) => {
  return execute(route, { method: "POST", body, ...options });
};

export const executeGet = async (route, options = {}) => {
  return execute(route, { method: "GET", ...options });
};

export const executePut = async (route, body, options = {}) => {
  return execute(route, { method: "PUT", body, ...options });
};

export const executeDelete = async (route, options = {}) => {
  return execute(route, { method: "DELETE", ...options });
};
